import React, { useEffect,useState } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { LINKTYPE, OVERLAY } from "@constants";
import {useVideoType,useVideoId} from "@store/video";
import useHeaderStore from "@store/header";

import "./linkWrapper.scss";

const LinkWrapper = ({ fields, children, clickHandler, hashId }) => {
  const setMenuOverlayActive = useHeaderStore(
    (state) => state.setMenuOverlayActive
  );
  const [,setVideoType] = useVideoType();
  const [,setVideoId] = useVideoId();
  
  const [link,setLink] = useState(fields?.link || fields || null);
  
  const overlay = fields?.command;
  const overlayExists = Object.values(OVERLAY).includes(overlay?.value.toUpperCase());

  const openOverlayHandler = () => {
    setMenuOverlayActive(overlay.value.toUpperCase());
  };

  useEffect(() => {
    setLink(fields?.link || fields || null)
  }, [fields]);

  const getLinkFragment = () => {
    if (overlay && overlayExists) {
      return <button onClick={openOverlayHandler}>{children}</button>;
    }
    else if (link) {
      switch (link?.value?.linktype?.toUpperCase() || LINKTYPE.INTERNAL) {
        case LINKTYPE.INTERNAL:
          return <NavLink onClick={clickMotionTagHandler} className="link-wrapper link-wrapper--internal" to={link.value.href} id={hashId}>{children}</NavLink>
        case LINKTYPE.EXTERNAL:
        case LINKTYPE.MAILTO:
          return <a className="link-wrapper link-wrapper--external" href={link.value?.href} title={link.value.title} target={link.value.target}>{children}</a>
        case LINKTYPE.JAVASCRIPT:
          return <a className="link-wrapper link-wrapper--javascript" href={link.value?.url}>{children}</a>
        default:
          return <>{children}</>
      };
    }
    else {
      return children;
    }
  }

  const clickMotionTagHandler = () => {
    if(hashId){
      window && window.history.replaceState(
        {scrollY:window.scrollY},
        "persist scroll position",
        "#"+hashId
        );
    } 
  };


  return (
    <>
        {fields?.videoType?.value && fields?.videoId?.value ? <>
          <a className="link-wrapper link-wrapper--video" href={link?.value?.href || "#"} onClick={event=>{
            event.stopPropagation();
            event.preventDefault();
            
            setVideoType(fields.videoType.value);
            setVideoId(fields.videoId.value);
          }}>{children}</a>
        </> 
        : 
        <>
        {getLinkFragment()}
      </>}
    </>
  );
};

LinkWrapper.propTypes = {
  fields: PropTypes.object,
  clickHandler: PropTypes.func,
};

export default LinkWrapper;
